import * as tslib_1 from "tslib";
import { Component, ComponentFactoryResolver, Inject, Input, KeyValueDiffer, KeyValueDiffers, OnChanges, SimpleChanges, Type, ViewChild, ViewContainerRef, } from '@angular/core';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ComponentFactoryResult, JssComponentFactoryService } from '../jss-component-factory.service';
import { PLACEHOLDER_MISSING_COMPONENT_COMPONENT } from './placeholder.token';
import { RawComponent } from './raw.component';
import { isRawRendering } from './rendering';
/**
 * Renders a single JSS component given a rendering definition.
 * Useful inside templated placeholders.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../jss-component-factory.service';

const _c0 = ["view"];
function RenderComponentComponent_ng_template_0_Template(rf, ctx) { }
let RenderComponentComponent = class RenderComponentComponent {
    constructor(componentFactoryResolver, differs, componentFactory, missingComponentComponent) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.differs = differs;
        this.componentFactory = componentFactory;
        this.missingComponentComponent = missingComponentComponent;
        this.destroyed = false;
    }
    set inputs(value) {
        this._inputs = value;
        if (!this._differ && value) {
            this._differ = this.differs.find(value).create();
        }
    }
    ngOnChanges(changes) {
        if (changes['rendering']) {
            this._render();
        }
    }
    _setComponentInputs(componentInstance, inputs) {
        Object.entries(inputs).forEach(([input, inputValue]) => componentInstance[input] = inputValue);
    }
    _subscribeComponentOutputs(componentInstance, outputs) {
        Object.keys(outputs)
            .filter((output) => componentInstance[output] && componentInstance[output] instanceof Observable)
            .forEach((output) => componentInstance[output]
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(outputs[output]));
    }
    _render() {
        this.view.clear();
        if (!this.rendering) {
            return;
        }
        const resolveComponent = isRawRendering(this.rendering)
            ? Promise.resolve({ componentImplementation: RawComponent, componentDefinition: this.rendering })
            : this.componentFactory.getComponent(this.rendering);
        resolveComponent.then((rendering) => {
            if (!rendering.componentImplementation) {
                const componentName = rendering.componentDefinition.componentName;
                console.error(`Attempted to render unknown component ${componentName}.`, `Ensure component is mapped, like:
          JssModule.withComponents([
            { name: '${componentName}', type: ${componentName}Component }
          ])`);
                rendering.componentImplementation = this.missingComponentComponent;
            }
            const componentFactory = rendering.componentFactory || this.componentFactoryResolver.resolveComponentFactory(rendering.componentImplementation);
            const componentInstance = this.view.createComponent(componentFactory, 0).instance;
            componentInstance.rendering = rendering.componentDefinition;
            if (this._inputs) {
                this._setComponentInputs(componentInstance, this._inputs);
            }
            if (this.outputs) {
                this._subscribeComponentOutputs(componentInstance, this.outputs);
            }
        });
    }
};
RenderComponentComponent.ɵfac = function RenderComponentComponent_Factory(t) { return new (t || RenderComponentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.JssComponentFactoryService), ɵngcc0.ɵɵdirectiveInject(PLACEHOLDER_MISSING_COMPONENT_COMPONENT)); };
RenderComponentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RenderComponentComponent, selectors: [["sc-render-component"]], viewQuery: function RenderComponentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.view = _t.first);
    } }, inputs: { inputs: "inputs", rendering: "rendering", outputs: "outputs" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["view", ""]], template: function RenderComponentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RenderComponentComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2 });
RenderComponentComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: KeyValueDiffers },
    { type: JssComponentFactoryService },
    { type: Type, decorators: [{ type: Inject, args: [PLACEHOLDER_MISSING_COMPONENT_COMPONENT,] }] }
];
tslib_1.__decorate([
    Input()
], RenderComponentComponent.prototype, "rendering", void 0);
tslib_1.__decorate([
    Input()
], RenderComponentComponent.prototype, "outputs", void 0);
tslib_1.__decorate([
    ViewChild('view', { read: ViewContainerRef, static: true })
], RenderComponentComponent.prototype, "view", void 0);
tslib_1.__decorate([
    Input()
], RenderComponentComponent.prototype, "inputs", null);
RenderComponentComponent = tslib_1.__decorate([ tslib_1.__param(3, Inject(PLACEHOLDER_MISSING_COMPONENT_COMPONENT))
], RenderComponentComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RenderComponentComponent, [{
        type: Component,
        args: [{
                selector: 'sc-render-component',
                template: `
    <ng-template #view></ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc1.JssComponentFactoryService }, { type: ɵngcc0.Type, decorators: [{
                type: Inject,
                args: [PLACEHOLDER_MISSING_COMPONENT_COMPONENT]
            }] }]; }, { inputs: [{
            type: Input
        }], rendering: [{
            type: Input
        }], outputs: [{
            type: Input
        }], view: [{
            type: ViewChild,
            args: ['view', { read: ViewContainerRef, static: true }]
        }] }); })();
export { RenderComponentComponent };
